import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const cashtagJourneyRoutes = [
  {
    id: 'initiate-payment',
    trackingName: 'Initiate Payment',
    path: 'web/view/cashtag/initiate-payment',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashtagInitiatePayment')).JourneyCashtagInitiatePayment,
    }),
    target: 'fullscreen',
  },
] as const satisfies JourneyRoute[]
